export function isDevelopmentEnv(): boolean {
  const tempGlobal: any = global || {};
  return tempGlobal.__DEV__ || global?.process?.env?.NODE_ENV === "development";
}
